import { useMutation, useQueryClient } from 'react-query';

import { applicantDetailsKey, applicantDetailsRoute } from '@features/applicant';
import {
  enterpriseApplicationsKey,
  updateApplicationNotesRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useUpdateEnterpriseApplicationRatingProps = {
  searchValue: string;
};

export const useUpdateEnterpriseApplicationRating = ({
  searchValue,
}: useUpdateEnterpriseApplicationRatingProps) => {
  const client = useQueryClient();
  const { mutate: updateEnterpriseApplicationRating } = useMutation({
    mutationFn: (variables: { rating: number | string; application_id: number, company_id: number }) =>
      axiosInstance
        .post(updateApplicationNotesRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {

    },
  });
  return { updateEnterpriseApplicationRating };
};
